import * as React from "react";
import {ValuableItemWithStartDate, Image, OnlineRentersClaimRequest} from "@falcon/services";
import {Overlay} from "@athena-portal/components";
import {ClaimImagePanel} from "./ClaimImagePanel";
import {v4 as uuid} from "uuid";
// @ts-ignore
import imageCompression from "browser-image-compression";

interface IProps {
    item: ValuableItemWithStartDate;
    onImagesAdding: (itemId: string, images: Image[]) => void;
    onImageRemoving: (itemId: string, imageId: string) => void;
    onlineRentersClaimRequest: OnlineRentersClaimRequest;
}

interface IState {
    imageError: Record<string, boolean>,
    showOverlay: boolean
}

export default class ClaimImageUploadPanel extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            imageError: {},
            showOverlay: false
        };

        this.compressImage = this.compressImage.bind(this);
    }

    public componentDidMount(): void {
    }

    public render(): React.ReactNode {
        const images = this.props.onlineRentersClaimRequest.itemsForClaim[this.getClaimItemIndex()].images || [];

        return (
            <>
                <div className="photo my-3">
                    {this.renderImages(images)}
                    {images.length < 2 && this.renderImageUploader(images)}
                    <Overlay show={this.state.showOverlay}/>
                </div>
                {this.state.imageError[this.props.item.id] && (
                    <div className="invalid-feedback d-block">
                        <b>Oops, you’ve uploaded invalid image type. Try again using .jpg, .jpeg, .png</b>
                    </div>
                )}
            </>
        );
    }

    private renderImages = (images: Image[]): React.ReactNode => {
        if (images && images.length > 0) {
            return (
                <div className="p-2">
                    {...images.map((image: Image, index: number) => (
                        <div key={index}>
                            {index > 0 && <div className="dashed-10 my-2"/>}
                            <ClaimImagePanel item={this.props.item}
                                             image={image}
                                             onRemove={this.props.onImageRemoving}/>
                        </div>
                    ))}
                </div>
            )
        } else {
            return <></>
        }
    };

    private getClaimItemIndex = (): number => {
        return this.props.onlineRentersClaimRequest.itemsForClaim.map((item: any) => item.itemId).indexOf(this.props.item.valuableItemId)
    };

    private renderImageUploader = (images: Image[]): React.ReactNode => {
        return (
            <>
                <div className="mt-2 mb-4"><b>Upload image or receipt of your item (optional)</b></div>
                <div>
                    <label htmlFor={`item-${this.props.item.valuableItemId}-image-upload-input`}>
                        <img src="/img/Flow-plus.svg" alt="Upload image icon"/>
                    </label>
                    <input type="file"
                           id={`item-${this.props.item.valuableItemId}-image-upload-input`}
                           accept=".jpg, .jpeg, .png"
                           className="d-none"
                           onChange={(e: any) => this.getFile(e, images)}/>
                </div>
            </>
        )
    };

    private compressImage(image: File, options: any): Promise<File> {
        return imageCompression(image, options);
    }

    private getFile = async (event: any, images: Image[]) => {
        const file = event.target.files[0];
        const objectId: string = this.props.item.id;
        this.setState({imageError: {[objectId]: false}})
        if (file) {
            let compressedFile = null;
            try {
                compressedFile = await this.compressImage(file, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1920,
                    useWebWorker: false
                });
            } catch (e) {
                this.setState({showOverlay: false, imageError: {[objectId]: true}})
            }
            if (compressedFile) {
                const reader = new FileReader;
                reader.readAsDataURL(compressedFile);
                reader.onload = () => {
                    const id: string = uuid();
                    const request: Image = new Image();
                    request.base64 = reader.result as string;
                    request.id = id;
                    images.push(request);
                    this.props.onImagesAdding(this.props.item.valuableItemId, images);
                }
            }
        }
    };
}
